import { render } from "./ControlloStorniRid.vue?vue&type=template&id=7016c477&scoped=true"
import script from "./ControlloStorniRid.vue?vue&type=script&lang=js"
export * from "./ControlloStorniRid.vue?vue&type=script&lang=js"

import "./ControlloStorniRid.vue?vue&type=style&index=0&id=7016c477&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7016c477"]])

export default __exports__